import { getIsoPosition } from './index';
import { createCommandButton, createTable } from './RexUI';
import { spawnAvailableMoveTiles, clearAvailableMoveTiles } from './Command/Move';
import { spawnAvailableAttackTiles, clearAvailableAttackTiles } from './Command/Attack';
import { endThisTurn } from './Command/End';
import TextKeys from '../../constants/TextKeys';
import TextureKeys from '../../constants/TextureKeys';
import {
  HERO_INIT_POS,
  HERO_INIT_ISO_POS,
  HERO_INIT_FRAME_RIGHT,
} from '../../configs/Battle';

// Initialize debug label for the scene
export function spawnDebugLabel() {
  this.debugLabel = this.add.text(
    this.cameras.main.width * 0.05,
    this.cameras.main.height * 0.05,
  );
}

// Initialize tile map for the scene
export function spawnTiles(xGrids, yGrids, tileSize) {
  const scene = this;
  let posX = 0;

  for (let isoPosX = 0; isoPosX < xGrids * tileSize; isoPosX += tileSize) {
    let posY = 0;

    for (let isoPosY = 0; isoPosY < yGrids * tileSize; isoPosY += tileSize) {
      this.tiles[posX][posY] = this.add.isoSprite(
        isoPosX,
        isoPosY,
        0,
        TextureKeys.tile,
        this.isoGroup,
      );
      this.tiles[posX][posY].setInteractive();
      this.tiles[posX][posY].on('pointerover', function () {
        scene.handlePointerOver.call(this, scene);
      });
      this.tiles[posX][posY].on('pointerout', function () {
        scene.handlePointerOut.call(this, scene);
      });
      this.tiles[posX][posY].on('pointerdown', function () {
        scene.handlePointerDown.call(this, scene);
      });
      posY++;
    }

    posX++;
  }
}

// Initialize team table for the scene
export function spawnTeamTable(data) {
  const x = 1062;
  const y = 604;
  const minWidth = 300;
  const minHeight = undefined;

  const table = { data };

  createTable.call(this, x, y, minWidth, minHeight, table);
}

// Initialize heros for the scene
export function spawnHeros() {
  this.heros.map((hero, index) => {
    const { posX, posY } = HERO_INIT_POS[index];
    const { isoPosX, isoPosY } = getIsoPosition(this.tiles[posX][posY]);
    const { isoPosZ } = HERO_INIT_ISO_POS;

    hero.posX = posX;
    hero.posY = posY;
    hero.isoSprite = this.add
      .isoSprite(isoPosX, isoPosY, isoPosZ, hero.name)
      .setFrame(HERO_INIT_FRAME_RIGHT);

    this.isoPhysics.world.enable(hero.isoSprite);

    return hero;
  });
}

// Initialize command buttons for the scene
export function spawnCommandButtons(isMoveDisable = false) {
  this.commandButtons = this.rexUI?.add
    .buttons({
      x: this.cameras.main.width * 0.09,
      y: this.cameras.main.height * 0.8,
      orientation: 'y',
      buttons: [
        createCommandButton.call(this, TextKeys.Move, isMoveDisable),
        createCommandButton.call(this, TextKeys.Attack),
        createCommandButton.call(this, TextKeys.Skill),
        createCommandButton.call(this, TextKeys.End),
      ],
      space: { item: 16 },
    })
    .layout();

  this.commandButtons?.on('button.click', (button, index) => {
    switch (index) {
      case 0: {
        if (this.availableMoveTiles.length) {
          clearAvailableMoveTiles.call(this)
        } else {
          spawnAvailableMoveTiles.call(this);
        }
        break;
      }
      case 1: {
        if (this.availableAttackTiles.length) {
          clearAvailableAttackTiles.call(this)
        } else {
          spawnAvailableAttackTiles.call(this);
        }
        break;
      }
      case 2: {
        break;
      }
      case 3: {
        endThisTurn.call(this);
        break;
      }
      default: {
        break;
      }
    }
  });
}
